module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0